// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"634":"0c675329","856":"0c675329","934":"1d500c3b"}[chunkId] + ".chunk.css";
};